import { Link } from 'react-router-dom';
import { Button } from '@voilajsx/uikit/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@voilajsx/uikit/card';
import { Layers } from 'lucide-react';
import { Header } from '../../../shared/components';

const components = [
  { name: 'Button', category: 'Form', desc: 'Clickable buttons with variants' },
  { name: 'Input', category: 'Form', desc: 'Text input fields' },
  { name: 'Textarea', category: 'Form', desc: 'Multi-line text input' },
  { name: 'Checkbox', category: 'Form', desc: 'Toggle checkboxes' },
  { name: 'Switch', category: 'Form', desc: 'Toggle switches' },
  { name: 'Slider', category: 'Form', desc: 'Range slider input' },
  { name: 'Card', category: 'Display', desc: 'Content containers' },
  { name: 'Badge', category: 'Display', desc: 'Status indicators' },
  { name: 'Avatar', category: 'Display', desc: 'User avatars' },
  { name: 'Progress', category: 'Display', desc: 'Progress indicators' },
  { name: 'Skeleton', category: 'Display', desc: 'Loading placeholders' },
  { name: 'Alert', category: 'Feedback', desc: 'Alert messages' },
  { name: 'Tabs', category: 'Navigation', desc: 'Tabbed content' },
  { name: 'Accordion', category: 'Navigation', desc: 'Collapsible sections' },
  { name: 'Tooltip', category: 'Overlay', desc: 'Hover tooltips' },
];

const categories = ['Form', 'Display', 'Feedback', 'Navigation', 'Overlay'];

const SandboxIndex = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />

      <main className="max-w-6xl mx-auto px-4 py-12">
        {/* Hero */}
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-accent/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Layers className="w-8 h-8 text-accent" />
          </div>
          <h1 className="text-4xl font-bold mb-4">Component Sandbox</h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Explore {components.length} UIKit components with live previews and copy-paste code.
          </p>
        </div>

        {/* Categories */}
        {categories.map((category) => {
          const categoryComponents = components.filter((c) => c.category === category);

          return (
            <section key={category} className="mb-12">
              <h2 className="text-2xl font-semibold mb-6">{category} Components</h2>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {categoryComponents.map((component) => (
                  <Link key={component.name} to={`/sandbox/${component.name.toLowerCase()}`}>
                    <Card className="h-full hover:border-primary/50 transition-colors cursor-pointer">
                      <CardHeader className="pb-2">
                        <CardTitle className="text-lg">{component.name}</CardTitle>
                        <CardDescription>{component.desc}</CardDescription>
                      </CardHeader>
                      <CardContent>
                        <Button variant="outline" size="sm" className="w-full">
                          View Component
                        </Button>
                      </CardContent>
                    </Card>
                  </Link>
                ))}
              </div>
            </section>
          );
        })}

        {/* Back to tutorials */}
        <div className="mt-12 text-center">
          <p className="text-muted-foreground mb-4">
            Want to learn how to use these components?
          </p>
          <Link to="/tutorials">
            <Button variant="outline">
              Go to Tutorials
            </Button>
          </Link>
        </div>
      </main>
    </div>
  );
};

export default SandboxIndex;
